module.exports = __webpack_public_path__ + "SH.png?1f71963cfbb0cf36fc17e98db9b123b6";